import * as React from "react";
import { CartoContext } from "./carto-context";
export function withCarto(Component) {
  return React.forwardRef((props, ref) => {
    return (
      <CartoContext.Consumer>
        {contexts => <Component ref={ref} {...props} {...contexts} />}
      </CartoContext.Consumer>
    );
  });
}
